
import {defineComponent} from "vue";
import BaseButton from '@/components/BaseButton.vue';

export default defineComponent({
  name: "NewConfirmModal",
  components: {BaseButton},
  emits: ['onCancel', 'onConfirm'],
  props: {
    isVisible: Boolean,
    acceptCaption: {
      type: String,
      default: "Yes, accept it",
    },
    rejectCaption: {
      type: String,
      default: "No, don't accept",
    },
    title: {
      type: String,
      default: "Confirm and Accept"
    },
  },
})
